module.exports = __webpack_public_path__ + "static/media/404-img.d4a0a24f.png";